<template>
	<div class="searchzj-dw" @click.stop="serarchstop()">
		<div class="searchzj-dw1">
			<div class="searchzj-dw1-head">
				<p class="searchzj-dw1-head-p">主页</p>
				<div class="searchzj-mydiv">
					<input type="text" placeholder="请输入关键词" v-model="searchtitle" list="cars" />
					<button @click="getsearch(searchtitle)" @keyup.enter="getsearch(searchtitle)">搜索</button>
				</div>
				<datalist id="cars">
					<option :value="item" v-for="(item, index) in searchnote" :key="index"></option>
				</datalist>
			</div>
			<div class="searchzj-dw1-foot">
				<div class="searchzj-dw1-foot-div" :class="hh('/searchzixun')">
					<p @click.stop="tosearch('/searchzixun')">资讯</p>
				</div>
				<div class="searchzj-dw1-foot-div" :class="hh('/searchnovel')">
					<p @click.stop="tosearch('/searchnovel')">小说</p>
				</div>
				<div class="searchzj-dw1-foot-div" :class="hh('/searchcartoon')">
					<p @click.stop="tosearch('/searchcartoon')">漫画</p>
				</div>
			</div>
			<div class="searchnone"></div>
		</div>
		<searchnoresult v-if="nosearchshow"></searchnoresult>
	</div>
</template>

<script>
	import searchnoresult from "./search/searchnoresult.vue";
	export default {
		name: "App",
		props: ["actice"],
		components: {
			searchnoresult
		},
		data() {
			return {
				searchtitle: this.$route.query.searchtitle,
				searchnote: [],
				nosearchshow: false
			};
		},
		methods: {
			serarchstop() {},
			hh(path) {
				if (this.$route.path == path) {
					return "aaa";
				}
			},
			setnosearchshow(type) {
				console.log(type);
				if (type) {
					this.nosearchshow = true;
				} else {
					this.nosearchshow = false;
				}
			},
			setsearchnote() {
				// localStorage.removeItem("searchnote");
				// return;
				if (localStorage.getItem("searchnote")) {
					var searchnote1 = JSON.parse(localStorage.getItem("searchnote"));
				} else {
					var searchnote1 = [];
				}
				if (searchnote1.length > 10) {
					searchnote1.splice(10, searchnote1.length - 10);
				}
				searchnote1.unshift(this.searchtitle);
				localStorage.setItem("searchnote", JSON.stringify(searchnote1));
				this.getnew();
			},
			changenote(searchtitle) {
				this.searchtitle = searchtitle;
			},
			getsearch(searchtitle) {
				if (searchtitle) {
					this.$parent.getsearch(this.searchtitle);
					this.setsearchnote();
				}
			},
			getnew() {
				if (localStorage.getItem("searchnote")) {
					this.searchnote = [];
					var searchnote1 = JSON.parse(localStorage.getItem("searchnote"));
					let searchnote2 = new Set(searchnote1);
					this.searchnote.push(...searchnote2);
				}
			},
			tosearch(url) {
				this.$router.push({
					path: url,
					query: {
						searchtitle: this.searchtitle
					}
				});
			}
		},
		mounted() {
			this.getnew();
		} //生命周期 - 创建之前
	};
</script>

<style>
	.searchzj-dw {
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	.searchnone {
		display: flex;
		justify-content: center;
		width: 100%;
	}
	.searchzj-dw1 {
		width: 780px;
		height: 174px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 6px 8px 5px 0px rgba(0, 0, 0, 0.3);
		position: absolute;
		top: -70px;
		padding: 30px 60px;
		box-sizing: border-box;
		position: relative;
	}
	.searchzj-dw1-head {
		display: flex;
		justify-content: center;
		position: relative;
	}
	.searchzj-dw1-head-p {
		font-size: 18px;
		margin-right: 10px;
		line-height: 40px;
		width: 90px;
		text-align: center;
	}
	.searchzj-mydiv {
		display: flex;
	}
	.searchzj-mydiv1 {
		position: absolute;
		top: 40px;
		width: 320px;
		height: fit-content;
		max-height: 290px;
		background-color: #fff;
		border: 1px solid #cccccc;
		border-radius: 4px;
		box-sizing: border-box;
		margin-left: 5px;
		overflow-y: scroll;
		z-index: 100;
	}
	.searchzj-mydiv1 p:first-child {
		background-color: #e6e6e6 !important;
		color: #808080;
	}
	.searchzj-mydiv1-p {
		font-size: 14px !important;
		height: 30px;
		line-height: 30px;
		padding-left: 16px;
	}
	.searchzj-mydiv input {
		width: 320px;
		height: 40px;
		border: 1px solid rgba(0, 0, 0, 1);
		border-radius: 4px 0px 0px 4px;
		box-sizing: border-box;
		padding-left: 16px;
		font-size: 16px;
	}
	.searchzj-mydiv button {
		width: 90px;
		height: 40px;
		background: rgba(40, 163, 177, 1);
		border-radius: 0px 4px 4px 0px;
		border: 0;
		color: #fff;
		font-size: 16px;
	}
	.searchzj-dw1-foot {
		display: flex;
		margin-top: 30px;
	}
	.searchzj-dw1-foot-div {
		padding: 9px 20px;
		border-radius: 4px;
		margin-right: 10px;
	}
	.searchzj-dw1-foot-div p {
		font-size: 16px;
		color: #212121;
	}
	.aaa {
		background-color: rgba(40, 163, 177, 1);
		color: #fff !important;
	}
	.aaa p {
		color: #fff !important;
	}
	input::-webkit-calendar-picker-indicator {
		display: none;
		-webkit-appearance: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/searchzj.vue